/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Selectors for SettingsPositions component
 *
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.3.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../reducers/rootReducer';
import { ISettingsPositionsState } from './settingsPositionsReducer';
import { ISettingsPositionsItem } from './settingsPositionsTypes';

export const makeSelectSettingsPositions =
    (state: IRootReducer): ISettingsPositionsState => state.settings.settingsPositions;

export const makeSelectSettingsPositionsIsLoading = ():
    OutputSelector<IRootReducer, boolean, (state: ISettingsPositionsState) => boolean> =>
    createSelector(makeSelectSettingsPositions, (state) => state.isLoading);

export const makeSelectSettingsPositionsList = ():
    OutputSelector<IRootReducer, ISettingsPositionsItem[], (state: ISettingsPositionsState) =>
        ISettingsPositionsItem[]> => createSelector(makeSelectSettingsPositions, (state) => state.list);

export const makeSelectSettingsPositionsListSearch = ():
    OutputSelector<IRootReducer, string, (state: ISettingsPositionsState) => string> =>
    createSelector(makeSelectSettingsPositions, (state) => state.search);

export const makeSelectSettingsPositionsListHasMore = ():
    OutputSelector<IRootReducer, boolean, (state: ISettingsPositionsState) => boolean> =>
    createSelector(makeSelectSettingsPositions, (state) => state.hasMore);
